var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import { rawTimeZones } from '@vvo/tzdb';
import React from 'react';
import { findTimeZone } from '.';
import { DEFAULT_TIME_ZONE_NAME } from './Constant';
import TimeZoneSelect from './TimeZoneSelect';
import WorldMap from './WorldMap';
var useStyles = makeStyles({
    worldMap: {
        marginTop: 10
    }
});
var DEFAULT_TITLE = 'Time Zone';
var DEFAULT_DESCRIPTION = 'Select a time zone in the list or click an area on the map.';
var DEFAULT_BUTTON_LABEL_OK = 'OK';
var DEFAULT_BUTTON_LABEL_CANCEL = 'Cancel';
function DefaultButton(props) {
    var children = props.children, rest = __rest(props, ["children"]);
    return (_jsx(Button, __assign({ variant: "contained" }, rest, { children: children })));
}
var State;
(function (State) {
    State["Closed"] = "CLOSED";
    State["Open"] = "OPEN";
})(State || (State = {}));
function findTimeZoneWithDefault(timeZoneName) {
    var timezone = findTimeZone(timeZoneName);
    if (timezone) {
        return timezone;
    }
    else {
        var defaultTimezone = findTimeZone(DEFAULT_TIME_ZONE_NAME);
        if (defaultTimezone) {
            return defaultTimezone;
        }
        else {
            // Actually this would not happen. Just for TypeScript checking.
            return rawTimeZones[0];
        }
    }
}
export function TimeZoneSelectDialog(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, _c = _a.timeZoneName, givenTimeZoneName = _c === void 0 ? DEFAULT_TIME_ZONE_NAME : _c, _d = _a.title, title = _d === void 0 ? DEFAULT_TITLE : _d, _e = _a.description, description = _e === void 0 ? DEFAULT_DESCRIPTION : _e, _f = _a.buttonLabelOk, buttonLabelOk = _f === void 0 ? DEFAULT_BUTTON_LABEL_OK : _f, _g = _a.buttonLabelCancel, buttonLabelCancel = _g === void 0 ? DEFAULT_BUTTON_LABEL_CANCEL : _g, SubstituteButtonOk = _a.SubstituteButtonOk, SubstituteButtonCancel = _a.SubstituteButtonCancel, _h = _a.isOkFirstButton, isOkFirstButton = _h === void 0 ? false : _h;
    // Sanitize the initial timezone.
    var initialTimeZoneName = findTimeZoneWithDefault(givenTimeZoneName).name;
    var _j = React.useState(State.Closed), state = _j[0], setState = _j[1];
    var _k = React.useState(initialTimeZoneName), timeZoneName = _k[0], setTimeZoneName = _k[1];
    var classes = useStyles();
    // Initialize the time zone on opening the dialog.
    React.useEffect(function () {
        if (state === State.Closed && open) {
            setState(State.Open);
            setTimeZoneName(initialTimeZoneName);
        }
    }, [open, state]);
    var handleOK = function () {
        setState(State.Closed);
        if (onClose) {
            onClose(timeZoneName);
        }
    };
    var handleCancel = function () {
        setState(State.Closed);
        if (onClose) {
            onClose(initialTimeZoneName); // revert
        }
    };
    var handleTimeZoneChange = function (newTimeZoneName) {
        setTimeZoneName(newTimeZoneName);
    };
    var ButtonOk = SubstituteButtonOk !== null && SubstituteButtonOk !== void 0 ? SubstituteButtonOk : DefaultButton;
    var ButtonCancel = SubstituteButtonCancel !== null && SubstituteButtonCancel !== void 0 ? SubstituteButtonCancel : DefaultButton;
    var buttons = isOkFirstButton ? (_jsxs(React.Fragment, { children: [_jsx(ButtonOk, __assign({ onClick: handleOK }, { children: buttonLabelOk })), _jsx(ButtonCancel, __assign({ onClick: handleCancel }, { children: buttonLabelCancel }))] })) : (_jsxs(React.Fragment, { children: [_jsx(ButtonCancel, __assign({ onClick: handleCancel }, { children: buttonLabelCancel })), _jsx(ButtonOk, __assign({ onClick: handleOK }, { children: buttonLabelOk }))] }));
    return (_jsxs(Dialog, __assign({ onClose: handleCancel, "aria-labelledby": "time-zone-select-dialog-title", open: open, maxWidth: 'lg' }, { children: [_jsx(DialogTitle, __assign({ id: "time-zone-select-dialog-title" }, { children: title })), _jsx(DialogContent, { children: _jsxs(Container, { children: [_jsx(Box, { children: _jsx(DialogContentText, { children: description }) }), _jsx(Box, { children: _jsx(TimeZoneSelect, { timeZoneName: timeZoneName, onChange: handleTimeZoneChange }) }), _jsx(Box, __assign({ className: classes.worldMap }, { children: _jsx(WorldMap, { timeZoneName: timeZoneName, onChange: handleTimeZoneChange }) }))] }) }), _jsx(DialogActions, { children: buttons })] })));
}
//# sourceMappingURL=TimeZoneSelectDialog.js.map